import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronLeft, ChevronRight, User, LogOut, Settings } from 'lucide-react';

const UserProfileMenu = ({ user }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('auth_token');
    localStorage.clear(); // Clear all localStorage
    window.location.href = '/'; // Navigate to home instead of reload
  };

  return (
    <div className="user-menu-container">
      <div 
        className="user-menu"
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      >
        <div className="user-avatar">
          <span>{user.name.charAt(0).toUpperCase()}</span>
        </div>
        <span className="user-name">
          {user.is_admin ? 'Admin' : user.name}
        </span>
      </div>
      
      {isDropdownOpen && (
        <div className="user-dropdown">
          <div className="dropdown-header">
            <span>{user.name}</span>
            <small>{user.email}</small>
          </div>
          {user.is_admin && (
            <button 
              className="dropdown-item"
              onClick={() => {navigate('/admin'); setIsDropdownOpen(false);}}
            >
              <Settings size={16} />
              Admin Panel
            </button>
          )}
          <button 
            className="dropdown-item logout"
            onClick={handleLogout}
          >
            <LogOut size={16} />
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

const TopBar = ({ user }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 18) return 'Good afternoon';
    return 'Good evening';
  };

  const getPageTitle = () => {
    const path = location.pathname;
    if (path === '/') return getGreeting();
    if (path === '/search') return 'Search';
    if (path === '/library') return 'Your Library';
    if (path === '/liked') return 'Liked Songs';
    if (path.startsWith('/vibe/')) {
      const vibeId = path.split('/')[2];
      const vibeNames = {
        'abundance': 'Abundance Altar',
        'main-character': 'Main-Character Energy',
        'rave': 'Rave',
        'feel-good': 'Feel-good', 
        'slow-down': 'Slow it Down'
      };
      return vibeNames[vibeId] || 'Vibe';
    }
    return 'MetaSoul® Music';
  };

  return (
    <div className="top-bar">
      <div className="top-bar-nav">
        <button 
          className="nav-button"
          onClick={() => navigate(-1)}
          disabled={location.pathname === '/'}
        >
          <ChevronLeft size={20} />
        </button>
        <button 
          className="nav-button"
          onClick={() => navigate(1)}
        >
          <ChevronRight size={20} />
        </button>
      </div>

      <div className="top-bar-title">
        <h1>{getPageTitle()}</h1>
      </div>

      {/* Mobile Logo - Only visible on mobile */}
      <div className="top-bar-mobile-logo">
        <img 
          src="https://customer-assets.emergentagent.com/job_77252820-ffcc-44ae-9911-934317cd0f3d/artifacts/9m1db118_MetaSoul%20Music%20Logo%20SQUARE%20larger%20words.png"
          alt="MetaSoul® Music"
          onClick={() => navigate('/')}
        />
      </div>
    </div>
  );
};

export default TopBar;